import SocialBar from "./socialbar";
import { SiTwitter, SiGithub, SiLinkedin } from "react-icons/si";
import Icon from "../../UI/Icon";
import { AiFillMail } from "react-icons/ai";
const Socials = () => {
  return (
    <SocialBar>
      <div className="social-bar-wrapper">
        <div className="social-bar__icons">
          <Icon href="https://x.com/BroCode1508">
            <SiTwitter />
          </Icon>
          <Icon href="https://github.com/abhishekraj15">
            <SiGithub />
          </Icon>
          <Icon href="https://www.linkedin.com/in/abhishek-rajput-127887186/">
            <SiLinkedin />
          </Icon>
          <Icon href="mailto: rabhi0766@gmail.com">
            <AiFillMail />
          </Icon>
        </div>
        <footer>Copyright @abhishekraj15</footer>
      </div>
    </SocialBar>
  );
};
export default Socials;
